import { useContext, useState } from 'react';

// Components
import { Aside } from '@/components/Aside/Aside';
import { More } from '@/components/More/More';
import { ProductDescription } from '@/components/ProductDescription/ProductDescription';
import { ProductHeading } from '@/components/ProductHeading/ProductHeading';
import { ProductImage } from '@/components/ProductImage/ProductImage';
import { SmartDescription } from '@/components/SmartDescription/SmartDescription';
import { Context } from '@/components/Store';
import { useResize } from '@/lib/hooks';
// Modules
import { getProductImage, isSmart } from '@/lib/util';

const ProductRight = () => {
	const [state] = useContext(Context);
	const [detailsOpen, setDetailsOpen] = useState(isDesktop);

	/**
	 * Determine whether is desktop or mobile
	 * @return {boolean}
	 */
	function isDesktop() {
		return window.innerWidth >= 1280;
	}

	const productName = state?.bundle?.name ? state.bundle.name : '';

	const productImage = state && state.bundle ? getProductImage(state.bundle) : null;

	useResize(() => setDetailsOpen(isDesktop));

	return (
		<Aside>
			<details className="aside--content u-scrollbar" open={detailsOpen}>
				<summary>
					<span>
						<span className="summary-title">Ihre Auswahl: {productName}</span>
						<span className="form--button form--button-xs form--button-weak">
							Details{' '}
							<svg aria-hidden="true" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
								<path
									d="M11 7V9H13V7H11M14 17V15H13V11H10V13H11V15H10V17H14M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12M20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12Z"
									fill="currentcolor"
								/>
							</svg>
						</span>
					</span>
				</summary>
				<div className="aside-product">
					{productImage ? (
						<ProductImage productImage={productImage} productName={productName} />
					) : null}
					{productName ? <ProductHeading productName={productName} /> : null}
					<div className="product-content">
						{state.bundle &&
						(isSmart(state.bundle) ||
							state.bundle.contractSubscriptionGroup?.toLowerCase() === 'supporter') ? (
							<SmartDescription />
						) : (
							<ProductDescription />
						)}
					</div>
					<More />
				</div>
			</details>
		</Aside>
	);
};

export { ProductRight };
